module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.17903/js/img/valuePropModals/ReportBuilder/ValueProp2.svg"